import React, { useState } from 'react';

const AddEdgeModal = ({ isOpen, onClose, nodes = [], ciphers = [], onAdd }) => {
  const [source, setSource] = useState('');
  const [target, setTarget] = useState('');
  const [cipherId, setCipherId] = useState('');
  const [track, setTrack] = useState('GLOBAL');
  const [transitLog, setTransitLog] = useState('');

  if (!isOpen) return null;

  const baseCiphers = [
    { id: 'default_eso', type: 'sigil', code: 'SIGIL_LINK', visualData: null },
    { id: 'default_cri', type: 'cipher', code: 'CIPHER_LINK', visualData: null },
    ...ciphers
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!source || !target || !cipherId) return alert("Select Origin, Target, and Cipher.");
    if (source === target) return alert("Source and Target must be different.");
    
    const selectedCipher = baseCiphers.find(x => x.id === cipherId);
    // Pass the new narrative data back to the Matrix
    onAdd(source, target, selectedCipher, track, transitLog);
  };

  return (
    <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-[5000] p-4 backdrop-blur-md fade-in">
      <div className="bg-[#0a0a0a] border border-gray-800 p-8 w-full max-w-md rounded shadow-2xl flex flex-col gap-4 relative">
        <h3 className="text-white font-black uppercase tracking-widest border-b border-gray-900 pb-2">Add Narrative Vector</h3>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          
          <div className="flex gap-2">
              <div className="flex-1">
                <label className="text-[9px] text-gray-500 uppercase tracking-widest font-bold mb-1 block">Origin Node</label>
                <select className="w-full bg-[#111] border border-gray-800 text-white p-3 text-xs outline-none" value={source} onChange={e => setSource(e.target.value)}>
                  <option value="">-- SELECT --</option>
                  {nodes.map(n => <option key={n.id} value={n.id}>{n.label}</option>)}
                </select>
              </div>
              <div className="flex-1">
                <label className="text-[9px] text-gray-500 uppercase tracking-widest font-bold mb-1 block">Target Node</label>
                <select className="w-full bg-[#111] border border-gray-800 text-white p-3 text-xs outline-none" value={target} onChange={e => setTarget(e.target.value)}>
                  <option value="">-- SELECT --</option>
                  {nodes.map(n => <option key={n.id} value={n.id}>{n.label}</option>)}
                </select>
              </div>
          </div>

          <div className="flex gap-2">
              <div className="flex-[2]">
                <label className="text-[9px] text-gray-500 uppercase tracking-widest font-bold mb-1 block">Cipher Key</label>
                <select className="w-full bg-[#111] border border-gray-800 text-white p-3 text-xs outline-none" value={cipherId} onChange={e => setCipherId(e.target.value)}>
                  <option value="">-- SELECT --</option>
                  <option value="default_eso">[SIGIL] BLANK RED</option>
                  <option value="default_cri">[CIPHER] BLANK GREEN</option>
                  {ciphers.map(c => <option key={c.id} value={c.id}>[{c.type.toUpperCase()}] {c.code}</option>)}
                </select>
              </div>
              <div className="flex-1">
                <label className="text-[9px] text-gray-500 uppercase tracking-widest font-bold mb-1 block">Story Track</label>
                <select className="w-full bg-[#111] border border-gray-800 text-white p-3 text-xs outline-none" value={track} onChange={e => setTrack(e.target.value)}>
                  <option value="GLOBAL">Global</option>
                  <option value="BOB">Bob</option>
                  <option value="OPERATOR">Operator</option>
                  <option value="TAG">TAG</option>
                </select>
              </div>
          </div>

          <div>
              <label className="text-[9px] text-blue-500 uppercase tracking-widest font-bold mb-1 block">Transit Log (The Story Connective Tissue)</label>
              <textarea 
                  className="w-full bg-[#111] border border-blue-900/50 text-white p-3 text-sm outline-none focus:border-blue-500 h-24 custom-scrollbar" 
                  placeholder="e.g., Bob breached this door at 11:42 PM, using the sigil to jump to the alleyway..."
                  value={transitLog} 
                  onChange={e => setTransitLog(e.target.value)}
              />
          </div>

          <div className="flex gap-4 mt-2 border-t border-gray-900 pt-4">
            <button type="button" onClick={onClose} className="flex-1 p-3 text-gray-500 text-xs font-bold uppercase tracking-widest hover:text-white transition-colors border border-gray-800 rounded">Cancel</button>
            <button type="submit" className="flex-[2] bg-blue-900/40 border border-blue-800 text-white text-xs font-bold uppercase tracking-widest hover:bg-blue-600 transition-colors rounded">Lock Vector</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEdgeModal;